/**
 * DUNAMIS WEAR — Variant Picker
 */
(function () {
  'use strict';

  document.addEventListener('change', function (e) {
    const picker = e.target.closest('[data-variant-picker]');
    if (!picker) return;

    const form = picker.closest('form') || document.querySelector('[data-product-form]');
    const productJson = document.getElementById('ProductJSON');
    if (!productJson || !form) return;

    const product = JSON.parse(productJson.textContent);
    const selectedOptions = [];

    picker.querySelectorAll('[data-option-input]').forEach(function (input) {
      if (input.type === 'radio' && input.checked) selectedOptions.push(input.value);
      else if (input.tagName === 'SELECT') selectedOptions.push(input.value);
    });

    const variant = product.variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selectedOptions[i]; });
    });

    const idInput = form.querySelector('[name="id"]');
    const priceEl = document.querySelector('[data-product-price]');
    const atcBtn = form.querySelector('[type="submit"]');

    if (variant) {
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.innerHTML = theme.formatMoney(variant.price);
      if (atcBtn) {
        atcBtn.disabled = !variant.available;
        atcBtn.querySelector('.btn__text').textContent = variant.available
          ? theme.strings.addToCart
          : theme.strings.soldOut;
      }
      picker.querySelectorAll('[data-variant-swatch]').forEach(function (sw) {
        sw.classList.toggle('is-selected', sw.dataset.value === selectedOptions[sw.dataset.optionIndex]);
      });
      const colorName = document.querySelector('[data-selected-color]');
      if (colorName) colorName.textContent = selectedOptions[0] || '';
      const stickySize = document.querySelector('[data-sticky-size]');
      if (stickySize) {
        const sizeOption = selectedOptions.find(function (opt) {
          return ['P', 'M', 'G', 'GG'].indexOf(opt) !== -1;
        }) || selectedOptions[selectedOptions.length - 1] || '';
        stickySize.textContent = sizeOption ? ('Tamanho: ' + sizeOption) : '';
      }
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
  });

  document.addEventListener('click', function (e) {
    const swatch = e.target.closest('[data-variant-swatch]');
    if (!swatch) return;
    const radio = swatch.querySelector('input[type="radio"]');
    if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
  });

  function syncStickySizeFromPicker() {
    const picker = document.querySelector('[data-variant-picker]');
    const stickySize = document.querySelector('[data-sticky-size]');
    if (!picker || !stickySize) return;
    const selected = [];
    picker.querySelectorAll('[data-option-input]').forEach(function (input) {
      if (input.type === 'radio' && input.checked) selected.push(input.value);
      else if (input.tagName === 'SELECT') selected.push(input.value);
    });
    const sizeOption = selected.find(function (opt) {
      return ['P', 'M', 'G', 'GG'].indexOf(opt) !== -1;
    }) || selected[selected.length - 1] || '';
    stickySize.textContent = sizeOption ? ('Tamanho: ' + sizeOption) : '';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncStickySizeFromPicker);
  } else {
    syncStickySizeFromPicker();
  }
})();
